export const getGAUserID = () => {

    if (typeof window !== 'undefined' && typeof window.ga !== 'undefined') {
        const gtm_client_id = window.ga.getAll()[0].get('clientId');
        if (gtm_client_id)
            return gtm_client_id;
    }

    return false
}